"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeLegacyBearerToken = exports.getLegacyBearerToken = void 0;
const API_1 = require("../API");
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const getLegacyBearerToken = async (newBearerToken, baseURL = '/api/root/authentication/userAccessTokens/legacy') => {
    const bearerTokenRoutes = (0, API_1.createRoutes)(baseURL, newBearerToken, (axiosInstance) => ({
        getLegacyBearerToken: () => {
            return axiosInstance.get('');
        },
    }));
    const api = (0, API_1.createRoutesProxy)(bearerTokenRoutes);
    return api
        .getLegacyBearerToken()
        .then(({ data }) => {
        return (0, exports.decodeLegacyBearerToken)(data.token);
    })
        .catch((error) => {
        return Promise.reject(error);
    });
};
exports.getLegacyBearerToken = getLegacyBearerToken;
const decodeLegacyBearerToken = (legacyBearerToken) => {
    const legacyToken = {
        token: legacyBearerToken,
        claims: (0, jwt_decode_1.default)(legacyBearerToken),
    };
    return legacyToken;
};
exports.decodeLegacyBearerToken = decodeLegacyBearerToken;
